import React from 'react';
import './Footer.css';

export default class Footer extends React.Component {
  render() {
    return (
      <div className="footer">
        <ul className="footer-links">
          <p><a className="footer-more-info-sol" rel="noopener noreferrer" href="https://fraenkelgallery.com/tag/sol-lewitt" target="_blank" alt="a link to more information about sol lewitt">learn more about sol lewitt</a></p>
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js